import TitleSection from 'components/common/TitleSection';

const CeoMessage = () => {
  const titleDetail = {
    upperTitle: 'aRIF HUSSAIN',
    middleTitle: 'CEO’s Message',
    ceoDesignation: 'CEO (Chief Executive Officer)',
  };
  return (
    <section
      className='DBlock py-10 px-6 md:px-10 bg-eventLightPink'
      style={{
        background: `url("/assets/images/about-us/aboutCeoBg.png") no-repeat center/cover`,
      }}>
      <div className='max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4'>
        <div className='lg:col-span-1 order-1 sm:order-0'>
          <img
            className='w-full'
            src='/assets/images/about-us/ceoImg.png'
            alt='ceoImg'
          />
        </div>
        <div className='DBlock lg:col-span-2 order-0 sm:order-1'>
          <TitleSection titleDetail={titleDetail} />
          <p className='text-eventGray text-sm lg:text-base md:max-w-2xl font-light'>
            “We at CIEL are experts in our field of Event Management just as the
            name suggests. With a diverse team of talented and creative
            individuals, we prioritize client satisfaction and an event that
            makes memories forever. Let us make your dreams come true. Welcome
            to CIEL.”
          </p>
        </div>
      </div>
    </section>
  );
};

export default CeoMessage;
